import { useState } from 'react'
import { EVENT_ACTION, EVENT_ENTITY, sendDataHub, LANGUAGES } from '@hotmart/hub-components'

import './style.scss'

type Props = {
  locale: string
  ucode: string
  position: string
}

function FireBanner({ locale, ucode, position }: Props) {
  const [isDesktop] = useState(window.innerWidth >= 1024)
  const typeBanner = isDesktop ? 'desktop' : 'mobile'
  const newLocale = [LANGUAGES.PT_BR, LANGUAGES.EN, LANGUAGES.ES].includes(locale.toUpperCase()) ? locale : LANGUAGES.EN
  const banner = `/images/fire/${position}_${typeBanner}_${newLocale.toLowerCase()}.webp`

  const openFireSite = (position, link) => {
    sendDataHub(EVENT_ENTITY.USER, EVENT_ACTION.CLICK, '1.0', {
      userCode: ucode,
      operationType: `banner_fire`,
      operationValue: `${position}_${locale}`
    })

    window.open(link, '_blank')
  }

  if (position === 'header' && isDesktop) {
    return (
      <div className="fire_container pointer">
        <img className="_w-full" src={banner} onClick={() => openFireSite(position, process.env.SITE_FIRE_HEADER)} />
      </div>
    )
  } else if (position === 'footer') {
    return (
      <img
        src={banner}
        className="pointer _mb-6"
        style={{ width: '100%', borderRadius: '0.5rem' }}
        onClick={() => openFireSite(position, process.env.SITE_FIRE_FOOTER)}
      />
    )
  }
  return null
}

export default FireBanner
